import MultipleDragger, { type DraggerFieldProps } from '../../../components/fields/MultipleDraggerField';
import { InputContainer } from './shared';

const MultipleDraggerField = (props: DraggerFieldProps) => (
    <InputContainer>
        <MultipleDragger {...props} />
    </InputContainer>
);

export default MultipleDraggerField;
